module.exports = __webpack_public_path__ + "img/61.8f9bd65e.jpg";